import { IconButton } from "@chakra-ui/react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

interface EditButtonProps {
	onClick: () => void;
}

export function EditButton({ onClick }: EditButtonProps) {
	return (
		<IconButton
			onClick={onClick}
			aria-label="edit-field"
			variant="ghost"
			size="sm"
			color="#9E9AA3"
			_hover={{
				color: "black",
			}}
			icon={<FontAwesomeIcon icon={["far", "pencil"]} />}
		/>
	);
}
